namespace Matrix.Visualizer {
    export interface GraphEdgeForm {
        ParentNodeId: Serenity.IntegerEditor;
        ChildNodeId: Serenity.IntegerEditor;
        Caption: Serenity.StringEditor;
        Tooltip: Serenity.StringEditor;
        Thickness: Serenity.DecimalEditor;
        Colour: Serenity.StringEditor;
        FromArrow: Serenity.StringEditor;
        ToArrow: Serenity.StringEditor;
        FromArrowColour: Serenity.StringEditor;
        ToArrowColour: Serenity.StringEditor;
        ContextMenuTemplate: Serenity.StringEditor;
        RowId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        ParentNodeKey: Serenity.StringEditor;
        ChildNodeKey: Serenity.StringEditor;
    }

    export class GraphEdgeForm extends Serenity.PrefixedContext {
        static formKey = 'Visualizer.GraphEdge';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GraphEdgeForm.init)  {
                GraphEdgeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(GraphEdgeForm, [
                    'ParentNodeId', w0,
                    'ChildNodeId', w0,
                    'Caption', w1,
                    'Tooltip', w1,
                    'Thickness', w2,
                    'Colour', w1,
                    'FromArrow', w1,
                    'ToArrow', w1,
                    'FromArrowColour', w1,
                    'ToArrowColour', w1,
                    'ContextMenuTemplate', w1,
                    'RowId', w0,
                    'Version', w3,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'ParentNodeKey', w1,
                    'ChildNodeKey', w1
                ]);
            }
        }
    }
}
